module.exports = __webpack_public_path__ + "static/media/speed.762e7ef0.svg";